var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83203 18.499H6.83203C5.17518 18.499 3.83203 17.1559 3.83203 15.499V4.49902C3.83203 2.84217 5.17518 1.49902 6.83203 1.49902H14.832C16.4889 1.49902 17.832 2.84217 17.832 4.49902V6.49902H18.832C20.4889 6.49902 21.832 7.84217 21.832 9.49902V20.499C21.832 22.1559 20.4889 23.499 18.832 23.499H10.832C9.17518 23.499 7.83203 22.1559 7.83203 20.499V18.499ZM14.832 3.49902C15.3843 3.49902 15.832 3.94674 15.832 4.49902V6.49902L10.832 6.49902C9.17518 6.49902 7.83203 7.84217 7.83203 9.49902V16.499H6.83203C6.27975 16.499 5.83203 16.0513 5.83203 15.499L5.83203 4.49902C5.83203 3.94674 6.27975 3.49902 6.83203 3.49902L14.832 3.49902ZM19.832 9.49902L19.832 20.499C19.832 21.0513 19.3843 21.499 18.832 21.499H10.832C10.2797 21.499 9.83203 21.0513 9.83203 20.499L9.83203 9.49902C9.83203 8.94674 10.2797 8.49902 10.832 8.49902H18.832C19.3843 8.49902 19.832 8.94674 19.832 9.49902Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/iconCopy.4d9e9f090f4f2177b2105abcbb69cf2b.svg";
export { ForwardRef as ReactComponent };